import _jsx from "@babel/runtime/helpers/jsx";
var _SkholeIcon;
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { compose } from 'redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { Field, fieldArrayPropTypes } from 'redux-form';
import s from './MultipleSignersFormField.scss';
import SkholeIcon17 from '../../statelessComponents/Icons/SkholeIcon17';
import SkholeIcon13 from '../../statelessComponents/Icons/SkholeIcon13';
import TextField from '../../statelessComponents/FormFields/TextField';
var messages = defineMessages({
  deleteSignerLabel: {
    id: "MultipleSignersFormField.deleteSignerLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Delete signer"
    }]
  },
  addNewSignerLabel: {
    id: "MultipleSignersFormField.addNewSignerLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Add new signer"
    }]
  },
  nameLabel: {
    id: "MultipleSignersFormField.nameLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Signer "
    }, {
      "type": 1,
      "value": "index"
    }]
  },
  defaultSigner: {
    id: "MultipleSignersFormField.defaultSigner",
    defaultMessage: [{
      "type": 0,
      "value": "(default signer)"
    }]
  }
});
var MultipleSignersFormField = function MultipleSignersFormField(_ref // eslint-disable-line
) {
  var fields = _ref.fields,
    meta = _ref.meta,
    disabled = _ref.disabled,
    formatMessage = _ref.intl.formatMessage,
    maxSignersAmount = _ref.maxSignersAmount,
    defaultSigners = _ref.defaultSigners;
  return /*#__PURE__*/_jsx("div", {
    className: s.subtitlesContainer
  }, void 0, fields.map(function (signerEmail, index) {
    var isDefaultSigner = !!defaultSigners[index] && defaultSigners[index] === fields.get(index);
    return /*#__PURE__*/_jsx("div", {
      className: s.marginTop
    }, "signerEmail-".concat(signerEmail), /*#__PURE__*/_jsx("div", {
      className: s.subtitleRow
    }, void 0, /*#__PURE__*/_jsx(Field, {
      name: "".concat(signerEmail),
      type: "text",
      label: /*#__PURE__*/React.createElement(React.Fragment, null, formatMessage(messages.nameLabel, {
        index: index + 1
      }), ' ', isDefaultSigner && formatMessage(messages.defaultSigner)),
      margin: "normal",
      component: TextField,
      disabled: disabled || isDefaultSigner,
      fullWidth: true,
      multiline: true
    }), !disabled && !isDefaultSigner && /*#__PURE__*/_jsx(Tooltip, {
      title: formatMessage(messages.deleteSignerLabel),
      enterDelay: 200
    }, void 0, /*#__PURE__*/_jsx(Button, {
      "data-test-id": "6q6yVRFMK9nmQ_MxpMa5Y",
      onClick: function onClick() {
        return fields.remove(index);
      },
      style: {
        backgroundColor: 'transparent'
      },
      className: s.deleteSubtitleBtn
    }, void 0, _SkholeIcon || (_SkholeIcon = /*#__PURE__*/_jsx(SkholeIcon13, {})))), meta.error && meta.invalid && /*#__PURE__*/_jsx("span", {}, void 0, meta.error)));
  }), !disabled && /*#__PURE__*/_jsx("div", {
    className: s.addNewSubtitle
  }, void 0, /*#__PURE__*/_jsx(Tooltip, {
    title: formatMessage(messages.addNewSignerLabel),
    enterDelay: 200
  }, void 0, /*#__PURE__*/_jsx(Button, {
    "data-test-id": "pU4cXdw8z7ZOIiRSmKzN9",
    className: s.addNewBtn,
    onClick: function onClick() {
      return fields.push('');
    },
    "data-test": "add-new-signer-button",
    disabled: fields.length >= maxSignersAmount
  }, void 0, /*#__PURE__*/_jsx(SkholeIcon17, {
    className: s.addIcon
  }), /*#__PURE__*/React.createElement(FormattedMessage, messages.addNewSignerLabel)))));
};
export default compose(withStyles(s), injectIntl)(MultipleSignersFormField);